import { useTranslation } from 'react-i18next';
import { useMutation, useQueryClient } from 'react-query';

import { QUERY_KEYS } from 'consts/queryKeys';
import { useCustomToast } from 'hooks';
import { upsertPartnerCancellationPolicy } from 'modules/settings/api';

export const useMutationUpsertPartnerCancellationPolicy = (id?: string) => {
  const queryClient = useQueryClient();
  const { t } = useTranslation();
  const { successToast, errorToast } = useCustomToast();

  return useMutation(upsertPartnerCancellationPolicy, {
    onSuccess: response => {
      id === undefined
        ? successToast(t('policySuccessfullyEntered'))
        : successToast(t('policySuccessfullyEdited'));

      queryClient.refetchQueries(QUERY_KEYS.SETTINGS_CANCELLATION_POLICIES);
    },
    onError: () => {
      errorToast();
    },
  });
};
